import sound from './../../assets/sounds/pop-up-off.mp3'

import "./style.scoped.scss";

import { useState } from "react";
import { useLocation, Link } from "react-router-dom"

import clsx from "clsx";

import usePingOrders from "core/custom-hooks/usePingOrders";

const MishOrdersPinger = () => {

    const location = useLocation();

    const [ordersAlert, setDelivaryOrdersStatus] = useState(false);

    usePingOrders(setDelivaryOrdersStatus, sound);

    const [notifierEnabled, setDelivaryOrdersStatusNofifyer] = useState(true);

    const closeOrderConverfation = () => {
        setDelivaryOrdersStatusNofifyer(false)
    }

    return (
        <>
            {notifierEnabled && location.pathname !== "/order-confirmation" &&
                <div className={clsx({
                    notifier: true,
                    "open": ordersAlert
                })} >
                    <Link to="/order-confirmation">
                        <div>
                            <span className="closeNotifier" onClick={closeOrderConverfation}>
                                <i className="fa ion-android-close"></i>
                            </span>
                            <div>תזכורת לאישור הזמנה</div>
                        </div>
                    </Link>
                </div>
            }
        </>
    )
}

export default MishOrdersPinger;